module.exports = __webpack_public_path__ + "img/warning-status-icon.4413c1e9.svg";